/**
 * Analytics data is captured ONLY on the production app. Feature flags still
 * resolve everywhere (same SDK) — this gates what we SEND, not what we read.
 * Staging, Pages preview deployments (*.pages.dev), and localhost keep working
 * flags but emit no events, pageviews, replays, exceptions, or person
 * properties. The one exception is the SDK's own $identify, which flags need
 * for per-user targeting.
 */
export const PRODUCTION_HOSTNAMES: ReadonlySet<string> = new Set(['app.vertice.finance']);

export function isCaptureAllowed(
  hostname: string = typeof window !== 'undefined' ? window.location.hostname : '',
): boolean {
  return PRODUCTION_HOSTNAMES.has(hostname);
}
